export const notAuthRoutes = ['/visit-settings'];
